/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';

const originalTagMaxWidth = '200px';
const smallTagMaxWidth = '80px';
const mergePrDialogBranchNameMaxWidth = '97%';

export const BranchText = styled.span((props: { isFluidWidth: boolean }) => ({
  background: token('color.background.neutral'),
  // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
  borderRadius: token('radius.small', '3px'),
  color: token('color.text.subtle'),
  display: 'inline-block',
  font: token('font.body.UNSAFE_small'),
  fontWeight: token('font.weight.medium'),
  // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
  lineHeight: 1,
  padding: `${token('space.050')} ${token('space.100')}`,
  verticalAlign: 'middle',
  '&:hover, &:focus': {
    backgroundColor: token('color.background.neutral.hovered'),
  },
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  ...(props.isFluidWidth
    ? {
        maxWidth: mergePrDialogBranchNameMaxWidth,
        '@media (max-width: 600px)': {
          font: token('font.body.small'),
        },
      }
    : {
        maxWidth: originalTagMaxWidth,
        '@media (max-width: 1400px)': {
          maxWidth: '140px',
        },
        '@media (max-width: 900px)': {
          maxWidth: '100px',
        },
        '@media (max-width: 600px)': {
          font: token('font.body.UNSAFE_small'),
          maxWidth: smallTagMaxWidth,
        },
        '@media (max-width: 400px)': {
          maxWidth: '60px',
        },
        '@media (min-width: 1800px)': {
          maxWidth: '240px',
        },
        '@media (min-width: 2000px)': {
          maxWidth: '300px',
        },
        '@media (min-width: 2500px)': {
          maxWidth: '400px',
        },
      }),
}));
